module.exports = __webpack_public_path__ + "images/Logo_updated.svg";